module.exports = __webpack_public_path__ + "img/bim (4).294c8769.png";